export default function StepLinePrimitive(overlay, ctx, layout, candles) {
    
    if (candles.length < 2) return
    
    ctx.strokeStyle = overlay.lineColor
    ctx.lineWidth = overlay.lineWidth
    ctx.lineCap = 'square'
    ctx.lineJoin = 'miter'
    
    ctx.beginPath()
    
    // Start from the first candle
    let firstCandle = candles[0]
    let startX = layout.t2screen(firstCandle.raw[0])
    let startY = layout.$2screen(firstCandle.raw[4])
    ctx.moveTo(startX, startY)
    
    // Draw step line through all candle close prices
    for (let i = 1; i < candles.length; i++) {
        let prevCandle = candles[i - 1]
        let candle = candles[i]
        
        let prevX = layout.t2screen(prevCandle.raw[0])
        let currX = layout.t2screen(candle.raw[0])
        let currY = layout.$2screen(candle.raw[4])
        
        // Draw horizontal line to current timestamp
        ctx.lineTo(currX, startY)
        
        // Draw vertical line to current price
        ctx.lineTo(currX, currY)
        
        // Update the current Y for next iteration
        startY = currY
    }
    
    ctx.stroke()
}
